import { render, staticRenderFns } from "./BaseFrontOfficeBoard.vue?vue&type=template&id=bc01933c&scoped=true"
import script from "./BaseFrontOfficeBoard.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeBoard.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeBoard.vue?vue&type=style&index=0&id=bc01933c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc01933c",
  null
  
)

export default component.exports